module.exports = __webpack_public_path__ + "static/img/bg.3d762564.svg";